// extracted by mini-css-extract-plugin
export default {"addressSection":"IV-z","disabled":"JV-z","sectionButtons":"KV-z","logo":"LV-z"};